import { gql } from '@apollo/client';
import type { ISkillReferenceDTO } from '@sharedInterfaces/ISkill';
import GraphQL from '../graphQL';

const GET_ELIGIBLE_SUPERPOWER_SKILLS = gql`
    query GetEligibleSuperPowerSkills {
        getEligibleSuperPowerSkills {
            id
            title
            level
            isSuperPower
        }
    }
`;

export default async function getEligibleSuperPowerSkills(): Promise<ISkillReferenceDTO[]> {
    const result = await GraphQL.query<{ getEligibleSuperPowerSkills: ISkillReferenceDTO[] }>(
        GET_ELIGIBLE_SUPERPOWER_SKILLS,
        {},
    );
    return result.getEligibleSuperPowerSkills;
}
